<template>
    <div class="wrap">
        <div class="header_title">
            <div class="header_center">
                <div class="title">
                    申报:
                    <span>优质工程创优策划</span>
                </div>
                <div class="back_page" @click="backpage">返回上一页</div>
            </div>
        </div>
        <div class="form_box">
            <div class="nav_left">
                <div class="nav_title">导航</div>
                <div class="nav_list">
                    <!-- 导航栏列表 -->
                    <div class="list"
                         v-for="(item, index) in lefttitlelist"
                         :key="index" @click="scrollleft(item.elementid)">
                        <img class="tips" v-if="item.isok" src="@/assets/6598@2x.png" alt/>
                        <img class="tips" v-else src="@/assets/6668@2x.png" alt/>
                        <p>{{ item.name }}</p>
                    </div>
                </div>
                <div class="preview">
                    <!-- 左边三个按钮 -->
                    <div class="preservation" @click="SaveDraftleft">
                        <img src="@/assets/19158@2x.png" alt/>
                        <p>保存草稿</p>
                    </div>
                    <div class="online" @click="printPdf">
                        <img src="@/assets/19160@2x.png" alt/>
                        <p>在线预览</p>
                    </div>
                    <div
                        class="sumbit"
                        :class="issumbit ? 'blue' : ''"
                        v-btn-control="sumbit"
                    >
                        <img src="@/assets/19178@2x.png" alt/>
                        <p>提交平台审核</p>
                    </div>
                </div>
            </div>
            <div class="form_right" id="exportPdf" ref="exportPdf">
                <div class="form_1" id="title">
                    <Tips
                        title="填表须知"
                        background="#EDF8F5"
                        border="#1ABF98"
                        :states="true"
                    ></Tips>
                    <div
                        class="form_box_content"
                        style="text-align: start; font-size: 14px; color: #0c0d0f"
                    >
                        <p>
                            1、本企业郑重承诺所填数据皆为真实数据，无不实、捏造、造假情况，对上传所有内容负责；<br/>
                            2、请填写完所有内容后点击[提交平台审核]，提交后不可再进行修改。申报未提交时需要更换申报项目请惰咨香提交的项目后进行提交。申报内容已提交，需要添加新的项目时，点击申报填写新项目<br/>
                        </p>
                    </div>
                </div>
                <div class="form_1" id="Enterpriseoverview">
                    <Tips
                        title="项目简况"
                        :background="Enterpriseoverview ? '#EDF8F5' : '#FEF8EF'"
                        :border="Enterpriseoverview ? '#1ABF98' : '#FFB700'"
                        :states="Enterpriseoverview"
                    ></Tips>
                    <div class="my_form" style="margin-top: 20px">
                        <div class="form_title" style="height: 62px">工程名称</div>
                        <div class="form_long">
                            <input
                                placeholder="请输入"
                                type="text"
                                v-model="parmes.Enterpriseoverview.msg1"
                            />
                        </div>
                    </div>
                    <div class="my_form2">
                        <div class="form_title" style="height: 62px">申报单位</div>
                        <div class="form_long">
                            <input
                                placeholder="请输入"
                                type="text"
                                v-model="parmes.Enterpriseoverview.msg2"
                            />
                        </div>
                    </div>
                    <div class="flex">
                        <div class="my_form">
                            <div class="form_title" style="height: 62px">工程类别</div>
                            <div class="form_content">
                                <div class="input">
                                    <input
                                        type="text"
                                        placeholder="请输入"
                                        v-model="parmes.Enterpriseoverview.msg3"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="my_form">
                            <div class="form_title" style="height: 62px">建设规模</div>
                            <div class="form_content">
                                <div class="input">
                                    <input
                                        type="text"
                                        placeholder="请输入"
                                        v-model="parmes.Enterpriseoverview.msg4"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="my_form2">
                            <div class="form_title" style="height: 62px">开工时间</div>
                            <div class="form_content">
                                <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                                placeholder="选择日期"
                                                v-model="parmes.Enterpriseoverview.msg5"
                                                class="inpyabeb"></el-date-picker>
                            </div>
                        </div>
                        <div class="my_form2">
                            <div class="form_title" style="height: 62px">
                                计划竣工时间
                            </div>
                            <div class="form_content">
                                <div class="input">
                                    <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                                    placeholder="选择日期"
                                                    v-model="parmes.Enterpriseoverview.msg6"
                                                    class="inpyabeb"></el-date-picker>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="my_form">
                            <div class="form_title" style="height: 62px">建设地点</div>
                            <div class="form_long">
                                <input
                                    placeholder="请输入"
                                    type="text"
                                    v-model="parmes.Enterpriseoverview.msg7"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="my_form2">
                            <div class="form_title" style="height: 62px">最终质量目标</div>
                            <div class="form_content">
                                <el-select
                                    v-model="parmes.Enterpriseoverview.msg8"
                                    placeholder="请选择最终质量目标"
                                    class="inpyabeb"
                                    size="small"
                                >
                                    <el-option label="黄果树杯" value="黄果树杯"></el-option>
                                    <el-option label="国优奖" value="国优奖"></el-option>
                                    <el-option label="鲁班奖" value="鲁班奖"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="my_form2">
                            <div class="form_title" style="height: 62px">
                                申报联系人
                            </div>
                            <div class="form_content">
                                <div class="input">
                                    <input
                                        type="text"
                                        placeholder="请输入"
                                        v-model="parmes.Enterpriseoverview.msg9"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="my_form">
                            <div class="form_title" style="height: 62px">联系电话</div>
                            <div class="form_content">
                                <input
                                    type="text"
                                    placeholder="请输入"
                                    v-model="parmes.Enterpriseoverview.msg10"
                                />
                            </div>
                        </div>
                        <div class="my_form">
                            <div class="form_title" style="height: 62px">
                                邮箱
                            </div>
                            <div class="form_content">
                                <div class="input">
                                    <input
                                        type="text"
                                        placeholder="请输入"
                                        v-model="parmes.Enterpriseoverview.msg11"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form_1" id="Upload">
                    <Tips
                        title="上传附件"
                        :background="filelist.length ? '#EDF8F5' : '#FEF8EF'"
                        :border="filelist.length ? '#1ABF98' : '#FFB700'"
                        :states="filelist.length ? true : false"
                    ></Tips>
                    <div class="my_form2">
                        <div class="form_title" style="height: 100px">上传附件</div>
                        <div class="uploadcertificate">
                            <el-upload
                                class="upload-demo"
                                :action="$baseURL + '/api/home/upload/file/user'"
                                :on-success="(response, file, fileList) =>handleAdd(response, file, fileList, 0)"
                                :on-remove="handleremove"
                                :file-list="filelist"
                                accept=".doc, .docx,.pdf"
                            >
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div
                                    slot="tip"
                                    class="el-upload__tip"
                                    v-if="filelist.length < 1"
                                >
                                    请上传doc/docx/pdf文件，且不超过50mb
                                </div>
                            </el-upload>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>

<script>
import {
    AddHighqualityReport, highquality_report_temp, highquality_report_temp_detail,
} from "../../utils/api";
import Footer from "@/components/Footer";
import Tips from "@/components/Modal/tips"; //提示组件
export default {
    components: {
        Tips,
        Footer,
    },
    data() {
        return {
            issumbit: true, //是否可以提交审核
            title: true, //填表须知 绿色高亮
            Enterpriseoverview: false, //企业概况 填空是否填完
            filelist: [],
            time: undefined,
            lefttitlelist: [
                {name: "填表须知", isok: true, elementid: "title"},
                {name: "项目简况", isok: false, elementid: "Enterpriseoverview"},
                {name: "上传附件", isok: false, elementid: "Upload"},
            ],
            parmes: {
                Enterpriseoverview: {},
            },
        };
    },
    created() {
        highquality_report_temp_detail(1).then((res) => {
            if (Array.isArray(res.content.Enterpriseoverview)) {
                res.content.Enterpriseoverview = {};
            }
            if(res.content.filelist){
                this.filelist = res.content.filelist;
            }
            console.log("myres", res);
            this.time = res.created_at
            this.parmes = res.content;
            console.log(this.time)
        });
        this.lefttitlelist.forEach((element) => {
            if (!element.isok) {
                this.issumbit = false;
            }
        });
    },
    watch: {
        parmes: {
            handler: function (newval, oldval) {
                this.issumbit = true;
                this.Enterpriseoverview = this.noempty(
                    this.parmes.Enterpriseoverview,
                    11,
                    "msg"
                );
                this.lefttitlelist[1].isok = this.Enterpriseoverview;
                this.lefttitlelist[2].isok = this.parmes.filelist
                    ? this.parmes.filelist.length >= 1
                        ? true
                        : false
                    : false;
                this.lefttitlelist.forEach((element) => {
                    if (!element.isok) {
                        this.issumbit = false;
                    }
                });
            },
            deep: true,
        },
    },
    methods: {
        //左侧导航栏锚点
        scrollleft(id) {
            this.scrollnum("#" + id);
        },
        //锚点滚动
        scrollnum(id) {
            document
                .querySelector(id)
                .scrollIntoView({behavior: "smooth", block: "start"});
            // document.querySelector(id).scrollIntoView(true)
            // document.documentElement.scrollTop = document.documentElement.scrollTop - 78
        },
        //非空验证 参数：根据对象名，对象内有多少条属性，属性名
        noempty(obj, num, name) {
            var empty = true;
            for (let i = 1; i <= num; i++) {
                if (obj[name + i] == "" || obj[name + i] == undefined) {
                    empty = false;
                }
            }
            return empty;
        },
        //上传附件
        handleChange(file) {
            this.filelist = [file];
            this.$set(this.parmes, "filelist", this.filelist);
        },
        //删除附件
        handleremove() {
            this.filelist = [];
            this.$set(this.parmes, "filelist", []);
        },
        handleAdd(response, file, fileList, index) {
            this.filelist = [file];
            this.$set(this.parmes, "filelist", this.filelist);
        },
        //返回上一页
        backpage() {
            this.$router.go(-1);
        },
        //保存草稿
        SaveDraftleft() {
            this.parmes.filelist = this.filelist;
            highquality_report_temp({
                achievement_id: this.$route.query.id,
                content: this.parmes,
            }).then((res) => {
                if (res) {
                    this.$message({
                        type: "success",
                        message: "保存草稿成功!",
                    });
                }
            });
        },
        //在线预览
        async printPdf() {
            highquality_report_temp({
                achievement_id: this.$route.query.id,
                content: this.parmes,
            }).then((res) => {
                if (res) {
                    sessionStorage.setItem("highquality", JSON.stringify(this.parmes));
                    sessionStorage.setItem("highquality_time", this.time);
                    this.$router.push("/word_2?title=优质工程创优策划");
                }
            });
        },
        //提交审核
        sumbit() {
            if (this.issumbit) {
                AddHighqualityReport({
                    content: this.parmes,
                }).then((res) => {
                    if (res) {
                        this.$message({
                            type: "success",
                            message: "申报优质工程创优策划项目成功!",
                        });
                        this.$router.go(-1)
                    }
                }).catch(err=>{
                    console.log(err,'err')
                    this.$message({
                        message: err,
                        type: "error",
                    });
                });
            } else {
                this.$message.error("请填写完所有资料再提交");
            }
        },
    },
};
</script>

<style lang="less" scoped>
.wrap {
    width: 100%;
    background: #eff3f8;

    .newadd {
        width: 100px;
        height: 36px;
        border: 1px solid #194abe;
        border-radius: 3px;
        text-align: center;
        line-height: 36px;
        color: #194abe;
        margin: 0 0 20px 20px;
        box-sizing: border-box;
        cursor: pointer;
    }

    .flex {
        display: flex;
        align-items: center;
    }

    .my_form,
    .my_form2 {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        overflow: auto;
        align-items: stretch;

        .form_title {
            background: #eaf0f6;
            width: 129px;
            min-width: 129px;
            height: auto;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 20px;
            padding: 0 6px;
            box-sizing: border-box;
            color: #0c0d0f;
        }

        .uploadinput {
            display: flex;
            flex-direction: column;
            justify-content: center;

            .uploadlist {
                display: flex;
                align-items: center;
            }

            input {
                width: 257px;
                height: 36px;
                background: #ffffff;
                border: 1px solid #bdc3cb;
                opacity: 1;
                border-radius: 4px;
                padding: 0 15px;
                box-sizing: border-box;

                &:focus {
                    outline: none;
                    border: 1px solid #194abe;
                }
            }

            .input {
                width: 257px;
                display: flex;
                position: relative;
                display: flex;
                align-items: center;
                margin-left: 20px;

                span {
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }

        .form_content,
        .form_long,
        .form_choice {
            width: 300px;
            padding: 0px 6px;
            background: #f5f8fb;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;

            input {
                width: 257px;
                height: 36px;
                background: #ffffff;
                border: 1px solid #bdc3cb;
                opacity: 1;
                border-radius: 4px;
                padding: 0 15px;
                box-sizing: border-box;

                &:focus {
                    outline: none;
                    border: 1px solid #194abe;
                }
            }

            .input {
                width: 257px;
                display: flex;
                position: relative;

                span {
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }

        .form_choice_long {
            display: flex;
            justify-content: start;
            align-items: center;
            width: 729px;
            padding-left: 20px;
            box-sizing: border-box;
            background: #f5f8fb;
        }

        .form_long {
            width: 729px;

            input {
                width: 688px;
            }
        }

        .form_textarea {
            width: 729px;
            height: 188px;
            display: flex;
            background: #f5f8fb;
            flex-direction: column;
            justify-content: space-evenly;
            padding-left: 20px;

            textarea {
                width: 688px;
                height: 127px;
                background: #ffffff;
                border: 1px solid #bdc3cb;
                opacity: 1;
                border-radius: 4px;
                padding: 9px 15px;
                box-sizing: border-box;
                color: #000;

                &:focus {
                    outline: none;
                    border: 1px solid #194abe;
                }
            }
        }

        .uploadimg {
            width: 729px;
            padding: 20px;
            background: #f5f8fb;
            box-sizing: border-box;
        }

        .Downinpustyle {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            background: #f5f8fb;

            .nejje {
                color: #194abe !important;
            }
        }

        .upload-demo {
            width: 729px;
            padding-left: 20px;
            background: #f5f8fb;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            height: 100px;

            .el-upload__tip {
                margin-left: 10px;
            }
        }
    }

    .my_formmin,
    .my_form2min {
        width: 286px;

        .form_title {
            width: 86px;
            min-width: 86px;
            padding: 20px 5px;
        }

        .form_content {
            width: 200px;
            display: flex;
            flex-direction: column;
        }

        input,
        .input {
            width: 171px !important;
            margin: 5px 0;
        }
    }

    .my_form {
    }

    .my_form2 {
        .form_title {
            background: #f5f8fb;
        }

        .form_content,
        .form_long,
        .form_textarea,
        .form_choice,
        .form_choice_long,
        .upload-demo,
        .Downinpustyle {
            background: #fbfdff;
        }
    }

    //   顶部title样式
    .header_title {
        width: 100%;
        margin: 0 auto;
        height: 58px;
        background: #ffffff;
        box-shadow: 0px 6px 12px rgba(0, 17, 58, 0.06);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999999;

        .header_center {
            width: 1200px;
            margin: 0 auto;
            height: 58px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title {
                font-size: 20px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                line-height: 29px;
                color: #0c0d0f;

                span {
                    font-size: 22px;
                    line-height: 32px;
                    color: #194abe;
                }
            }

            .back_page {
                cursor: pointer;
                width: 124px;
                height: 36px;
                background: #ffffff;
                border: 1px solid #c8cdd5;
                opacity: 1;
                border-radius: 6px;
                line-height: 36px;
                color: #7c828a;
            }
        }
    }

    // form_box样式
    .form_box {
        max-width: 1200px;
        min-width: 1200px;
        margin: 0 auto;
        margin-top: 78px;
        display: flex;
        justify-content: space-between;

        .tips {
            width: 20px;
            height: 20px;
        }

        .nav_left,
        .form_right {
            border-radius: 6px;
        }

        .nav_left {
            position: fixed;
            width: 268px;

            .nav_title,
            .nav_list {
                background: #ffffff;
                width: 100%;
                text-align: start;
                padding: 0 16px;
                box-sizing: border-box;
            }

            .nav_title {
                height: 53.5px;
                font-size: 20px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                line-height: 53.5px;
                color: #0c0d0f;
                border-radius: 6px 6px 0px 0px;
            }

            .nav_list {
                margin-top: 2px;
                height: 350px;
                overflow-y: scroll;
                overflow-x: hidden;
                border-radius: 0px 0px 6px 6px;

                &::-webkit-scrollbar {
                    width: 6px;
                    height: 1px;
                }

                &::-webkit-scrollbar-thumb {
                    border-radius: 5px;
                    background-color: #b7c8f1;
                }

                .list {
                    width: 100%;
                    height: 57px;
                    border-bottom: 1px dashed #d4dbdd;
                    display: flex;
                    align-items: center;

                    p {
                        margin-left: 13px;
                        font-size: 16px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        line-height: 24px;
                        overflow: hidden;
                        word-break: break-all;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                    }
                }
            }

            .preview {
                margin-top: 17px;
                width: 100%;
                height: 201px;
                padding: 16px;
                box-sizing: border-box;
                background: white;
                border-radius: 0px 0px 6px 6px;

                .preservation,
                .online,
                .sumbit {
                    cursor: pointer;
                    width: 236px;
                    height: 50px;
                    background: #ffffff;
                    opacity: 1;
                    border-radius: 4px;
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 15px;
                        height: 15px;
                        margin-right: 4px;
                    }
                }

                .blue {
                    background: #194abe !important;
                }

                .preservation {
                    border: 1px solid #194abe;
                    color: #194abe;
                }

                .online {
                    margin: 10px 0;
                    border: 1px solid #1abf98;
                    color: #1abf98;
                }

                .sumbit {
                    background: #d4dbdd;
                    border-radius: 4px;
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    line-height: 27px;
                    color: #ffffff;

                    img {
                        width: 18px;
                        height: 14px;
                    }
                }
            }
        }

        .form_right {
            margin-left: 300px;
            width: 918px;

            .flex {
                display: flex;
            }

            .flex-direction {
                flex-direction: column;
            }

            .form_1 {
                width: 100%;
                background: #ffffff;
                padding: 35px 30px;
                box-sizing: border-box;
                margin-bottom: 30px;
                border-radius: 6px;

                .border {
                    border-top: 1px dashed #9fa5ae;
                    margin: 20px 0;
                }

                .bord {
                    margin-top: 11px;
                    width: 858px;
                    height: 0px;
                    border: 1px solid #194abe;
                    position: relative;

                    img {
                        width: 11px;
                        height: 6px;
                        position: absolute;
                        top: -6px;
                        left: 37px;
                    }
                }

                .newlybuild {
                    margin: 0 auto;
                    cursor: pointer;
                    width: 221px;
                    height: 36px;
                    border: 2px solid #194abe;
                    border-radius: 4px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 7px;
                    }

                    p {
                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 14px;
                        color: #194abe;
                    }
                }

                .form_box_content {
                    width: 100%;
                    margin-top: 20px;

                    .form_title {
                        box-sizing: border-box;
                        text-align: start;
                        display: flex;
                        align-items: center;

                        p {
                            font-size: 16px;
                            font-family: Microsoft YaHei;
                            font-weight: bold;
                            line-height: 20px;
                            color: #0c0d0f;
                        }

                        .delete_icon {
                            cursor: pointer;
                            margin-left: 10px;
                            width: 61px;
                            height: 25px;
                            background: #ffffff;
                            border: 1px solid #f9656f;
                            opacity: 1;
                            border-radius: 6px;
                            display: flex;
                            align-items: center;
                            justify-content: space-evenly;

                            img {
                                width: 13px;
                                height: 14px;
                            }

                            p {
                                font-size: 14px;
                                font-family: Source Han Sans CN;
                                font-weight: 400;
                                line-height: 20px;
                                color: #f9656f;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
<style>
.el-message,
.el-message--error {
    z-index: 999999 !important;
}

.el-upload-list {
    height: 50px;
    display: flex;
    align-items: center;
}

.el-upload-list__item {
    transition: none !important;
}
</style>
